import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, Briefcase, Shield, GraduationCap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const CareersSection = ({ className }) => {
  const benefits = [
    {
      icon: Briefcase,
      title: 'Impactful Work',
      description: 'Work on projects that shape communities and expand mobility.',
    },
    {
      icon: GraduationCap,
      title: 'Growth & Development',
      description: 'Continuous learning with mentorship and advancement opportunities.',
    },
    {
      icon: Shield,
      title: 'Safety Culture',
      description: 'Industry-leading safety practices protecting our team every day.',
    },
    {
      icon: Users,
      title: 'Team Environment',
      description: 'Collaborative culture built on respect and shared success.',
    },
  ];

  return (
    <section className={cn('py-20 relative overflow-hidden', className)}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxjaXZpbCUyMGVuZ2luZWVyaW5nfGVufDB8fHx8MTc2NDE0MzU2OHww&ixlib=rb-4.1.0&q=85"
          alt="Team at work"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gray-900/90" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="text-red-500 font-semibold text-sm uppercase tracking-wider">Join Our Team</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white leading-tight">
              Build Your Career With Purpose
            </h2>
            <p className="mt-6 text-lg text-gray-300 leading-relaxed">
              Redspire is always looking for disciplined thinkers, curious builders, and safety-driven professionals. 
              Our teams work on impactful infrastructure projects that shape communities and expand mobility.
            </p>
            <div className="mt-8">
              <Link to="/careers">
                <Button className="bg-red-600 hover:bg-red-700 text-white px-8 group">
                  Explore Opportunities
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-2 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/15 transition-colors duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-red-600/20 flex items-center justify-center mb-4">
                  <benefit.icon className="w-6 h-6 text-red-500" />
                </div>
                <h4 className="font-semibold text-white mb-2">{benefit.title}</h4>
                <p className="text-gray-400 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersSection;
